import React from "react";
import MarketingDefault from "./MarketingDefault";
import UtilityDefault from "./UtilityDefault";
import Authentication from "./Authentication";
const CreateTemplate = ({
  selectedCategory,
  selectedSubCat,
  template,
  setTemplate,
  showPreview,
  setShowPreview,
  setMediaId
}) => {
  if (selectedCategory === "Marketing" && selectedSubCat === "Default") {
    return (
      <MarketingDefault
        template={template}
        setTemplate={setTemplate}
        selectedCategory={selectedCategory}
        selectedSubCat={selectedSubCat}
        setShowPreview={setShowPreview}
        showPreview={showPreview}
        setMediaId={setMediaId}
      />
    );
  }

  if (selectedCategory === "Marketing" && selectedSubCat === "Flow") {
    return <>Flow</>;
  }

  if (selectedCategory === "Utility" && selectedSubCat === "Default") {
    return (
      <UtilityDefault
        template={template}
        setTemplate={setTemplate}
        selectedCategory={selectedCategory}
        selectedSubCat={selectedSubCat}
        setShowPreview={setShowPreview}
        showPreview={showPreview}
      />
    );
  }



if (selectedCategory === "Authentication" && selectedSubCat === "one_time otp") {
    return (
      <Authentication
        template={template}
        setTemplate={setTemplate}
        selectedCategory={selectedCategory}
        selectedSubCat={selectedSubCat}
      />
    );
  }

  return <>Else</>;
};



export default CreateTemplate;
